import clsx from "clsx";

export const ProfileBadge = ({ image, onClick, gradientClass, className }) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        gradientClass ?? "border-gradient_2",
        "p-0.5 rounded-full w-fit cursor-pointer"
      )}
    >
      <img
        className={clsx("w-10 h-10 object-cover rounded-full", className)}
        src={image}
        alt="Profile_image"
        loading="lazy"
      />
    </div>
  );
};
